import { OpmSimulatedValue } from '@app/shared/models/contracts/enums/shared-enums';
import { enumToOptions } from '@app/shared/helpers';

export const OPM_SIMULATED_VALUE_OPTIONS = enumToOptions(OpmSimulatedValue);
